import styles from './style.postcss';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect, Person, AdultPicture, ApiCall } from 'omni-common-ui';
import { actions as userActions, accessors as UserAccessors, User } from 'data/Users';
import classnames from 'classnames';
import is from 'is_js';
import PropTypes from 'prop-types';
import UserCardPlaceholder from 'components/UserCardPlaceholder';

export class UserCard extends Component {
  componentDidMount() {
    this._setUp(this.props);
  }

  componentWillReceiveProps(props) {
    this._setUp(props);
  }

  _setUp(props) {
    if (is.not.empty(props.id)) {
      props.fetchUserIfNeeded(props.id);
    }
  }

  _renderDate(dateStr) {
    if (is.existy(dateStr)) {
      return <div className={styles.UserCard_date}>{dateStr}</div>;
    }
    return null;
  }

  render() {
    const { getLines, user, dateStr, className, isLoading } = this.props;

    if (! (user instanceof User)) {
      return <UserCardPlaceholder className={className}
          isLoading={isLoading} />;
    }

    return <Person className={classnames(styles.UserCard, this.props.className)}>
      {getLines(this.props)}
      {this._renderDate(dateStr)}
    </Person>;
  }
}

UserCard.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  fetchUserIfNeeded: PropTypes.func,
  isLoading: PropTypes.bool,
  user: PropTypes.shape(),
  dateStr: PropTypes.string,
  avatarClassName: PropTypes.string,
  getLines: PropTypes.func.isRequired,
};

UserCard.defaultProps = {
  getLines: ({ user, avatarClassName }) => [
    <AdultPicture className={classnames(styles.UserCard_picture, avatarClassName)}
        src={user.avatarUrl}
        gender={user.gender}
        key="UserCard#pic0" />,
    <div key="UserCard#item0">{user.firstName} {user.lastName}</div>,
  ],
};

function mapStateToProps(state, ownProps) {
  const callState = userActions.getApiCallState(state, ownProps.id);
  return {
    user: UserAccessors.getUserByUserId(state, ownProps.id),
    isLoading: ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(userActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCard);



// WEBPACK FOOTER //
// ./components/UserCard/index.jsx